import {
  GET_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  GET_USER_SETTING,
  FETCH_USER_SETTING_SUCCESS,
  FETCH_USER_SETTING_FAILURE,
  GET_USER_COMPANIES,
  FETCH_VESSEL_WATCHlIST, FETCH_VESSEL_WATCHlIST_SUCCESS, FETCH_VESSEL_WATCHlIST_FAILURE,
  SAVE_CURRENT_COMPANY,
  SAVE_CURRENT_COMPANY_SUCCESS,
  SAVE_CURRENT_COMPANY_FAILURE
} from '../action/user.action'
import { apiRequest } from "../action/api.action"
import { FETCH_USER_COMPANIES_SUCCESS, FETCH_USER_COMPANIES_FAILURE } from "../action/user.action";

export const userFlow = ({ dispatch }) => next => action => {
  next(action)

  if (action.type === GET_USER) {
    let URL = "/api/v1/user/current";
    dispatch(apiRequest('GET', URL, null, FETCH_USER_SUCCESS, FETCH_USER_FAILURE));
  } else if (action.type === GET_USER_SETTING) {
    let URL = "/api/v1/user/settings";
    dispatch(apiRequest('GET', URL, null, FETCH_USER_SETTING_SUCCESS, FETCH_USER_SETTING_FAILURE));
  } else if (action.type === FETCH_USER_SETTING_SUCCESS) {
    let settings = {}
    if (action.payload['BUSINESS_GENERATOR_COLOR_FOR']) {
      settings.colorFor = action.payload['BUSINESS_GENERATOR_COLOR_FOR'];
    }
    if (action.payload['BUSINESS_GENERATOR_SHOW_ACTUAL_VESSEL_POSITION']) {
      settings.actualVesselPosition = ('true' === action.payload['BUSINESS_GENERATOR_SHOW_ACTUAL_VESSEL_POSITION'])
    }
    if (action.payload['BUSINESS_GENERATOR_HEATMAP_MONTHS']) {
      settings.heatmapMonths = action.payload['BUSINESS_GENERATOR_HEATMAP_MONTHS'];
    }
  } else if (action.type === GET_USER_COMPANIES) {
    let URL = "/api/v1/user/current/userCompanies/approved";
    dispatch(apiRequest('GET', URL, null, FETCH_USER_COMPANIES_SUCCESS, FETCH_USER_COMPANIES_FAILURE));
  } else if (action.type === FETCH_VESSEL_WATCHlIST) {
    let URL = "/api/v1/user/vessel-watchlists";
    dispatch(apiRequest('GET', URL, null, FETCH_VESSEL_WATCHlIST_SUCCESS, FETCH_VESSEL_WATCHlIST_FAILURE));
  } else if (action.type === SAVE_CURRENT_COMPANY) {
    let url = "/api/v1/user/settings";
    dispatch(apiRequest('PUT', url, action.payload, SAVE_CURRENT_COMPANY_SUCCESS, SAVE_CURRENT_COMPANY_FAILURE));
  } else if (action.type === SAVE_CURRENT_COMPANY_SUCCESS) {
    let URL = "/api/v1/user/settings";
    dispatch(apiRequest('GET', URL, null, FETCH_USER_SETTING_SUCCESS, FETCH_USER_SETTING_FAILURE));
  }

};

export const userMdl = [userFlow];